module.exports = __webpack_public_path__ + "img/bt_title3.67f39699.png";